

































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class UploadImagesModal extends Vue {
  @Prop(Number) groupId!: number;

  processFile(images: File[]) {
    this.$emit('uploadingImages', images);
    this.$emit('close');
  }
}
